/*
 * Load Polyfills
 */
import 'whatwg-fetch';
import '@babel/polyfill';

/**
 * Polyfill for Android browsers and the `ToString`
 * method on Samsung Browsers
 *
 * @see https://github.com/SamsungInternet/support/issues/56
 */
if (!Function.prototype.ToString) {
    Function.prototype.ToString = function () {
        return this.toString();
    };
}

// polyfill for CustomEvent otherwise Apple login breaks on IE 11
// see: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
( function() {
    if ( typeof window === 'undefined' || typeof window.CustomEvent === 'function' ) {
        return false;
    }

    /**
     * Replaces custom event function
     *
     * @param {string} event
     * @param {object} params
     * @return {*}
     * @constructor
     */
    function CustomEvent( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    window.CustomEvent = CustomEvent;
} )();
